var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_page"},[_c('div',{staticClass:"d-block"},[_c('i',{staticClass:"fas fa-graduation-cap icon"}),_vm._v(" "),_c('h5',{staticClass:"title"},[_vm._v("Select a module to start")])])])
}]

export { render, staticRenderFns }